// extracted by mini-css-extract-plugin
export default {"customTabContainer":"styles_customTabContainer__TMMKB","tabItemWrapper":"styles_tabItemWrapper__Prwed","tabItem":"styles_tabItem__1BB49","active":"styles_active__HcCKF"};